function createKautionDialogHTML(dynamicSachkontenOptions) {
  // const sachkonten = [
  //   "2001/M/1/2 Betriebskostenabrechung",
  //   "2001/M/1/3 Nebenkostenabrechung",
  //   "2001/M/1/4 Heizungsabrechung",
  // ];

  // const sachkontenOptions = sachkonten
  //   .map(konto => `<option value="${konto}">${konto}</option>`)
  //   .join('');

  return `
    <div id="kaution-dialog-content" style="background-color: white; padding: 20px; border-radius: 5px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); width: 800px; max-width: 90%; max-height: 90vh; overflow-y: auto; font-family: sans-serif;">
      <style>
        /* Basic styling for the dialog elements */
        #kaution-dialog-content h3 { margin-top: 20px; margin-bottom: 10px; font-size: 1.1em; font-weight: 600; border-bottom: 1px solid #eee; padding-bottom: 5px; }
        #kaution-dialog-content label { display: block; margin-bottom: 5px; font-weight: 500; }
        #kaution-dialog-content input[type="text"],
        #kaution-dialog-content input[type="number"],
        #kaution-dialog-content select {
          width: 100%;
          padding: 8px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          box-sizing: border-box; /* Include padding and border in element's total width and height */
        }
        #kaution-dialog-content .radio-group div { display: flex; align-items: center; margin-bottom: 5px; }
        #kaution-dialog-content .radio-group input[type="radio"] { margin-right: 8px; }
        #kaution-dialog-content button {
          padding: 8px 15px;
          border: 1px solid #ccc;
          border-radius: 4px;
          cursor: pointer;
          background-color: #f0f0f0;
        }
        #kaution-dialog-content button.primary { background-color: black; color: white; border-color: black; }
        #kaution-dialog-content .button-group { display: flex; justify-content: space-between; margin-top: 20px; border-top: 1px solid #eee; padding-top: 15px; }
        #kaution-dialog-content .button-group div { display: flex; gap: 10px; }
        #kaution-dialog-content table { width: 100%; border-collapse: collapse; margin-top: 15px; }
        #kaution-dialog-content th, #kaution-dialog-content td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        #kaution-dialog-content th { background-color: #f2f2f2; }
        #kaution-dialog-content td.text-right { text-align: right; }
        #kaution-dialog-content .hidden { display: none; }
        #kaution-dialog-content .indented { padding-left: 25px; margin-top: 10px; border-left: 2px solid #eee; }
        #kaution-dialog-content .grey-box { background-color: #f8f9fa; padding: 10px; border-radius: 4px; margin-top: 5px; }
        #kaution-dialog-content .grey-box p { margin: 0; color: #6c757d; font-size: 0.9em;}

        /* Styles for dynamic deduction rows */
        #deduction-rows-container { margin-top: 10px; }
        .deduction-row { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 10px; padding-bottom: 10px; border-bottom: 1px solid #eee; }
        .deduction-row > div { flex: 1; }
        .deduction-row .amount-col { flex: 0 0 120px; } /* Fixed width for amount */
        .deduction-row .account-col { flex: 1; } /* Flexible width for account */
        .deduction-row .note-col { flex: 1; } /* Flexible width for note */
        .deduction-row .delete-col { flex: 0 0 40px; display: flex; align-items: center; padding-top: 25px; /* Align button roughly with inputs */ }
        .deduction-row label { font-size: 0.9em; margin-bottom: 3px; color: #555; }
        .deduction-row input,
        .deduction-row select,
        .deduction-row textarea { width: 100%; padding: 6px; font-size: 0.95em; margin-bottom: 0; /* Remove margin-bottom from original style */ }
        .deduction-row textarea { 
            resize: vertical; 
            min-height: 34px; /* Match input height */ 
            /* Explicitly set border styles for consistency */
            border: 1px solid #ccc;
            border-radius: 4px;
            box-sizing: border-box;
        }
        .delete-deduction-btn { background: none; border: none; cursor: pointer; padding: 5px; color: #dc3545; opacity: 0.7; }
        .delete-deduction-btn:hover { opacity: 1; }
        .delete-deduction-btn svg { width: 16px; height: 16px; }

        #add-deduction-btn { /* Mimic Impower's add button */
            background-color: rgba(0, 0, 0, .06);
            border: 1px dashed #d9d9d9;
            color: rgba(0, 0, 0, .85);
            padding: 5px 15px;
            cursor: pointer;
            display: inline-flex; /* Use inline-flex */
            align-items: center;
            gap: 5px;
            border-radius: 4px;
            margin-top: 5px;
            font-size: 0.9em;
            transition: all 0.3s;
            font-weight: bold; /* Make text bold */
        }
        #add-deduction-btn:hover {
            border-color: black; /* Changed from #1890ff */
            color: black; /* Changed from #1890ff */
        }
        #add-deduction-btn svg { width: 12px; height: 12px; }

      </style>
      <h2>Kaution</h2>
      <div id="kaution-dialog-form">
        <!-- 1. Art der Kaution -->
        <div class="section-art-kaution">
            <h3>1. Art der Kaution</h3>
            <div class="radio-group" id="kaution-type-group">
                <div>
                    <input type="radio" id="kaution-nicht-im-system" name="kautionType" value="nicht-im-system">
                    <label for="kaution-nicht-im-system">Nicht im System hinterlegt (Microvisions)</label>
                </div>
                <div>
                    <input type="radio" id="kaution-bereits-im-system" name="kautionType" value="bereits-im-system">
                    <label for="kaution-bereits-im-system">Bereits im System hinterlegt</label>
                </div>
            </div>
        </div>

        <!-- 2. Kaution -->
        <div class="section-kaution">
            <h3>2. Kaution</h3>
            <div id="kaution-details-nicht-im-system" class="hidden">
                <div>
                    <label for="kaution-betrag">Betrag</label>
                    <input type="number" id="kaution-betrag" placeholder="0.00" step="0.01">
                </div>
                <div>
                    <label for="kaution-buchungsdatum">Buchungsdatum</label>
                    <div id="kaution-buchungsdatum-mount"></div>
                </div>
            </div>
            <div id="kaution-details-bereits-im-system" class="hidden grey-box">
                <p>Die Kautionsdaten werden aus dem Mietvertrag übernommen</p>
            </div>
        </div>

        <!-- 3. Auszahlung -->
        <div class="section-auszahlung">
            <h3>3. Auszahlung</h3>
            <div class="radio-group" id="auszahlung-type-group">
                <div>
                    <input type="radio" id="auszahlung-gesamt" name="auszahlungType" value="gesamt">
                    <label for="auszahlung-gesamt">Gesamte Kaution wird ausgezahlt</label>
                </div>
                <div>
                    <input type="radio" id="auszahlung-teil" name="auszahlungType" value="teil">
                    <label for="auszahlung-teil">Teil der Kaution wird ausgezahlt</label>
                </div>
            </div>
            <div id="auszahlung-details-teil" class="hidden indented">
                <!-- Container for dynamic deduction rows -->
                <div id="deduction-rows-container">
                   <!-- Rows will be rendered here by JS -->
                </div>
                 <!-- Add Deduction Button -->
                <button type="button" id="add-deduction-btn">
                    <svg viewBox="64 64 896 896" focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"><defs><style></style></defs><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"></path></svg>
                    Einbehalt hinzufügen
                </button>
            </div>
        </div>

         <!-- 4. Zahlungsanweisung -->
        <!--<div class="section-zahlung">
            <h3>4. Zahlungsanweisung</h3>
            <div class="radio-group" id="zahlung-type-group">
                <div>
                    <input type="radio" id="zahlung-ueberweisung" name="zahlungType" value="ueberweisung">
                    <label for="zahlung-ueberweisung">Überweisung erstellen</label>
                </div>
                <div>
                    <input type="radio" id="zahlung-keine" name="zahlungType" value="keine">
                    <label for="zahlung-keine">Keine Zahlung erstellen</label>
                </div>
            </div>
        </div> -->

        <!-- Tabular Overview -->
        <div class="section-uebersicht">
            <h3>Übersicht</h3>
            <table>
                <thead>
                    <tr>
                        <th>Beschreibung</th>
                        <th class="text-right">Betrag</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Gesamte Kaution</td>
                        <td class="text-right" id="uebersicht-gesamt">0.00 €</td>
                    </tr>
                    <tr>
                        <td>
                           Einbehalt
                           <span id="uebersicht-sachkonto-info" class="hidden" style="display: block; font-size: 0.9em; color: grey;"></span>
                        </td>
                        <td class="text-right" id="uebersicht-einbehalt">0.00 €</td>
                    </tr>
                    <tr style="font-weight: bold;">
                        <td>Auszuzahlender Betrag</td>
                        <td class="text-right" id="uebersicht-auszahlung">0.00 €</td>
                    </tr>
                </tbody>
            </table>
        </div>

      </div>
      <div class="button-group">
        <button id="kaution-dialog-close">Zurück</button>
        <div>
          <!-- <button id="kaution-dialog-save-draft">Als Entwurf speichern</button> -->
          <button id="kaution-dialog-submit" class="primary">Zur Zahlung freigeben</button>
        </div>
      </div>
    </div>
  `;
}

function initKautionDialogLogic(modalContentElement, closeModalCallback, fetchedSachkontenOptionsHTML) {

  const form = modalContentElement.querySelector('#kaution-dialog-form');
  const kautionTypeGroup = form.querySelector('#kaution-type-group');
  const kautionDetailsNichtImSystem = form.querySelector('#kaution-details-nicht-im-system');
  const kautionDetailsBereitsImSystem = form.querySelector('#kaution-details-bereits-im-system');
  const kautionBetragInput = form.querySelector('#kaution-betrag');
  const kautionBuchungsdatumMount = form.querySelector('#kaution-buchungsdatum-mount');
  const kautionBuchungsdatumPicker = datePicker('kaution-buchungsdatum');
  kautionBuchungsdatumPicker.wrapper.id = 'kaution-buchungsdatum';
  kautionBuchungsdatumPicker.setDisabled(false);
  if (kautionBuchungsdatumMount) {
    kautionBuchungsdatumMount.replaceWith(kautionBuchungsdatumPicker.wrapper);
  }

  const auszahlungTypeGroup = form.querySelector('#auszahlung-type-group');
  const auszahlungDetailsTeil = form.querySelector('#auszahlung-details-teil'); // The container for dynamic rows + add button
  const deductionRowsContainer = form.querySelector('#deduction-rows-container');
  const addDeductionBtn = form.querySelector('#add-deduction-btn');

  const uebersichtGesamt = form.querySelector('#uebersicht-gesamt');
  const uebersichtEinbehalt = form.querySelector('#uebersicht-einbehalt');
  const uebersichtAuszahlung = form.querySelector('#uebersicht-auszahlung');
  const uebersichtSachkontoInfo = form.querySelector('#uebersicht-sachkonto-info');

  const closeButton = modalContentElement.querySelector('#kaution-dialog-close');
  const saveDraftButton = modalContentElement.querySelector('#kaution-dialog-save-draft');
  const submitButton = modalContentElement.querySelector('#kaution-dialog-submit');

  let nextDeductionId = 1;
  let state = {
      kautionType: null,
      auszahlungType: null,
      zahlungType: null,
      totalKaution: 0,
      deductions: [],
      amountToSend: 0,
      sachkontenOptionsHTML: fetchedSachkontenOptionsHTML || '<option value="">Konten nicht geladen</option>'
  };

  const formatCurrency = (value) => {
      const num = Number.parseFloat(value) || 0;
      return num.toFixed(2).replace('.', ',') + " €";
  }

  const calculateAmountToSend = () => {
      const totalEinbehalt = state.deductions.reduce((sum, deduction) => {
          return sum + (Number.parseFloat(deduction.amount) || 0);
      }, 0);
      state.amountToSend = state.totalKaution - totalEinbehalt;
      updateUebersicht(totalEinbehalt);
  };

  const updateUebersicht = (totalEinbehalt = null) => {
      if (totalEinbehalt === null) {
          totalEinbehalt = state.deductions.reduce((sum, deduction) => {
              return sum + (Number.parseFloat(deduction.amount) || 0);
          }, 0);
      }

      uebersichtGesamt.textContent = formatCurrency(state.totalKaution);
      uebersichtEinbehalt.textContent = formatCurrency(totalEinbehalt);
      uebersichtAuszahlung.textContent = formatCurrency(state.amountToSend);

      // Hide the single sachkonto info in the overview as there can be multiple
      uebersichtSachkontoInfo.classList.add('hidden');
      uebersichtSachkontoInfo.textContent = '';

  };

  const renderDeductionRows = () => {
      if (!deductionRowsContainer) return;
      deductionRowsContainer.innerHTML = '';

      if (state.deductions.length === 0) {
          // deductionRowsContainer.innerHTML = '<p style="color: #888; font-style: italic; font-size: 0.9em;">Noch keine Einbehalte hinzugefügt.</p>';
      }

      state.deductions.forEach(deduction => {
          const row = document.createElement('div');
          row.className = 'deduction-row';
          row.dataset.id = deduction.id;
          row.innerHTML = `
              <div class="amount-col">
                  <label for="deduction-amount-${deduction.id}">Betrag</label>
                  <input type="number" id="deduction-amount-${deduction.id}" class="deduction-amount" value="${deduction.amount || ''}" placeholder="0.00" step="0.01">
              </div>
              <div class="account-col">
                  <label for="deduction-account-${deduction.id}">Sachkonto</label>
                  <select id="deduction-account-${deduction.id}" class="deduction-account">
                      <option value="">Sachkonto auswählen</option>
                      ${state.sachkontenOptionsHTML}
                  </select>
              </div>
              <div class="note-col">
                  <label for="deduction-note-${deduction.id}">Buchungsnotiz</label>
                  <textarea id="deduction-note-${deduction.id}" class="deduction-note" placeholder="Optionale Notiz..." rows="1">${deduction.note || ''}</textarea>
              </div>
              <div class="delete-col">
                  <button type="button" class="delete-deduction-btn" title="Einbehalt löschen">
                      <svg fill="currentColor" viewBox="0 0 18 21"> <!-- Adjusted viewBox to match provided SVG -->
                        <path d="M3.26 21H14.74L16 7H2L3.26 21ZM13 4V2C13 1.46957 12.7893 0.960859 12.4142 0.585786C12.0391 0.210714 11.5304 0 11 0H7C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V4H0V6H18V4H13ZM11 4H7V2H11V4Z" fill="black"></path>
                      </svg>
                  </button>
              </div>
          `;
          const selectElement = row.querySelector(`#deduction-account-${deduction.id}`);
          if (selectElement) {
                selectElement.value = deduction.account;
          }
          deductionRowsContainer.appendChild(row);
      });
      calculateAmountToSend();
  };

  const updateVisibility = () => {
      // Section 2 Visibility
      kautionDetailsNichtImSystem.classList.toggle('hidden', state.kautionType !== 'nicht-im-system');
      kautionDetailsBereitsImSystem.classList.toggle('hidden', state.kautionType !== 'bereits-im-system');

       // Section 3 Visibility 
      auszahlungDetailsTeil.classList.toggle('hidden', state.auszahlungType !== 'teil');

      // Reset dependent fields when visibility changes
      if (state.kautionType !== 'nicht-im-system') {
           // TODO: Logic to fetch kaution if 'bereits-im-system' is selected
      }

      if (state.auszahlungType !== 'teil') {
          state.deductions = [];
          renderDeductionRows();       
        } else {
          if (state.deductions.length === 0) {
              addDeductionRow();
          }
      }

      calculateAmountToSend();
  };

  const addDeductionRow = () => {
      const newId = nextDeductionId++;
      state.deductions.push({ id: newId, amount: '', account: '', note: '' });
      renderDeductionRows();
  };

  // --- Event Listeners ---

  kautionTypeGroup.addEventListener('change', (event) => {
      if (event.target.name === 'kautionType') {
          state.kautionType = event.target.value;
          if(state.kautionType === 'bereits-im-system') {
              // TODO: Fetch kaution amount from system
              state.totalKaution = 1500;
              kautionBetragInput.value = formatCurrency(state.totalKaution).replace(' €','').replace(',','.'); // Update input field too
              kautionBetragInput.readOnly = true;
          } else {
               state.totalKaution = Number.parseFloat(kautionBetragInput.value) || 0;
               kautionBetragInput.readOnly = false;
          }
          updateVisibility();
          calculateAmountToSend();
      }
  });

  kautionBetragInput.addEventListener('input', (event) => {
      if (state.kautionType === 'nicht-im-system') {
         state.totalKaution = Number.parseFloat(event.target.value) || 0;
         calculateAmountToSend();
      }
  });

  auszahlungTypeGroup.addEventListener('change', (event) => {
      if (event.target.name === 'auszahlungType') {
          state.auszahlungType = event.target.value;
          updateVisibility();
      }
  });

  addDeductionBtn.addEventListener('click', addDeductionRow);

  deductionRowsContainer.addEventListener('input', (event) => {
      const target = event.target;
      const row = target.closest('.deduction-row');
      if (!row) return;
      const id = parseInt(row.dataset.id, 10);
      const deductionIndex = state.deductions.findIndex(d => d.id === id);
      if (deductionIndex === -1) return;

      if (target.classList.contains('deduction-amount')) {
          state.deductions[deductionIndex].amount = target.value;
          calculateAmountToSend(); 
      } else if (target.classList.contains('deduction-note')) {
          state.deductions[deductionIndex].note = target.value;
      }
  });

  deductionRowsContainer.addEventListener('change', (event) => {
        const target = event.target;
        const row = target.closest('.deduction-row');
        if (!row || !target.classList.contains('deduction-account')) return;
        const id = parseInt(row.dataset.id, 10);
        const deductionIndex = state.deductions.findIndex(d => d.id === id);
        if (deductionIndex === -1) return;

        state.deductions[deductionIndex].account = target.value;
        // console.log("Account selected for deduction", id, ":", target.value);
  });

  deductionRowsContainer.addEventListener('click', (event) => {
      const target = event.target;
      const deleteButton = target.closest('.delete-deduction-btn');
      if (!deleteButton) return;

      const row = deleteButton.closest('.deduction-row');
      if (!row) return;
      const id = parseInt(row.dataset.id, 10);

      state.deductions = state.deductions.filter(d => d.id !== id);
      renderDeductionRows();
  });

  deductionRowsContainer.addEventListener('dblclick', (event) => {
      const target = event.target;
      if (target.classList.contains('deduction-note')) {
           target.style.height = '';
      }
  });

  // Buttons
  if (closeButton) {
    closeButton.addEventListener('click', closeModalCallback);
  } else {
      console.error("Could not find close button");
  }

   if (saveDraftButton) {
       saveDraftButton.addEventListener('click', () => {
           console.log("Current State (Save Draft):", state);
           alert('Save Draft clicked (Check console for state)');
           // TODO: Save logic
        });
   }
    if (submitButton) {
         submitButton.addEventListener('click', async () => {
            console.log("Current State (Submit):", state);

            const payload = { 
                ...state,
                propertyHrId: null,
                unitContractId: null,
                deductions: state.deductions.map(d => ({
                    ...d,
                    amount: Number.parseFloat(d.amount) || 0
                 })),
                 kautionBetrag: Number.parseFloat(kautionBetragInput.value) || 0,
            };

            const urlPath = window.location.pathname;
            const urlMatch = urlPath.match(/properties\/([^/]+)\/.*?\/contract\/all\/edit\/([^/?]+)/);
            if (urlMatch && urlMatch.length >= 3) {
                payload.propertyHrId = urlMatch[1];
                payload.unitContractId = parseInt(urlMatch[2], 10);
            } else {
                alert("Fehler: Kontext konnte nicht erneut gelesen werden. Buchung abgebrochen.");
                return;
            }
             if (isNaN(payload.unitContractId)) {
                  alert("Fehler: Ungültige Vertrags-ID. Buchung abgebrochen.");
                  return;
             }

            submitButton.disabled = true;
            submitButton.textContent = 'Verarbeite...';

            try {
                 const token = JSON.parse(localStorage.getItem('auth'))?.token;
                 if (!token) throw new Error("Auth Token nicht gefunden.");

                 const response = await fetch(`${baseApiUrl}/api/impowerX/postings`, {
                     method: 'POST',
                     headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`
                     },
                     body: JSON.stringify(payload)
                 });

                 const result = await response.json();

                 if (response.ok && result.success) {
                     alert(result.message || "Buchungen erfolgreich erstellt!");
                     closeModalCallback();
                 } else {
                     console.error("Posting failed:", result);
                     alert(`Fehler beim Buchen: ${result.error || 'Unbekannter Fehler'}\n\nDetails: ${result.details || 'Keine Details'}`);
                 }

            } catch (error) {
                console.error("Error during fetch to /api/impowerX/postings:", error);
                alert(`Netzwerk- oder Skriptfehler beim Buchen: ${error.message}`);
            } finally {
                submitButton.disabled = false;
                submitButton.textContent = 'Zur Zahlung freigeben';
            }
         });
    }

    updateVisibility();
    updateUebersicht();
    if(state.auszahlungType === 'teil' && state.deductions.length === 0) {
        addDeductionRow();
    }
}

async function openKautionDialog() {
    if (document.getElementById('kaution-dialog-overlay')) {
        return;
    }

    let propertyHrId = null;
    let unitContractId = null;
    const urlPath = window.location.pathname;
    const urlMatch = urlPath.match(/properties\/([^/]+)\/.*?\/contract\/all\/edit\/([^/?]+)/);

    if (urlMatch && urlMatch.length >= 3) {
        propertyHrId = urlMatch[1];
        unitContractId = urlMatch[2];
        console.log(`openKautionDialog: Extracted propertyHrId=${propertyHrId}, unitContractId=${unitContractId}`);
    } else {
        console.error('openKautionDialog: Could not extract propertyHrId and unitContractId from URL:', urlPath);
        alert("Fehler: Kontext für Kautionsassistent konnte nicht ermittelt werden (IDs nicht gefunden).");
        return;
    }

    const modalOverlay = document.createElement('div');
    modalOverlay.id = 'kaution-dialog-overlay';
    modalOverlay.style.position = 'fixed';
    modalOverlay.style.top = '0';
    modalOverlay.style.left = '0';
    modalOverlay.style.width = '100%';
    modalOverlay.style.height = '100%';
    modalOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    modalOverlay.style.display = 'flex';
    modalOverlay.style.justifyContent = 'center';
    modalOverlay.style.alignItems = 'center';
    modalOverlay.style.zIndex = '99999';

    modalOverlay.innerHTML = `
        <div style="background:white; padding:30px; border-radius:5px; text-align:center; font-family: sans-serif;">
            <style>
                .spinner {
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    border-left-color: black;
                    margin: 10px auto;
                    animation: spin 1s ease infinite;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
            <div class="spinner"></div>
            Laden...
        </div>
    `;
    document.body.appendChild(modalOverlay);


    // --- Fetch Sachkonten ---
    let sachkontenOptionsHTML = '<option value="">Fehler beim Laden der Konten</option>'; // Default error message
    try {
        const token = JSON.parse(localStorage.getItem('auth'))?.token;
        if (!token) {
             throw new Error("Authentication token not found.");
        }

        const response = await fetch(`${baseApiUrl}/api/impowerX/accounts?propertyHrId=${propertyHrId}&unitContractId=${unitContractId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error("Failed to fetch Sachkonten:", response.status, errorData);
            throw new Error(errorData.error || `HTTP error ${response.status}`);
        }

        const data = await response.json();
        if (data.sachkonten && Array.isArray(data.sachkonten)) {
             if (data.sachkonten.length === 0) {
                 sachkontenOptionsHTML = '<option value="">Keine passenden Konten gefunden</option>';
             } else {
                 sachkontenOptionsHTML = data.sachkonten
                    .map(konto => `<option value="${konto}">${konto}</option>`)
                    .join('');
            }
        } else {
            console.error("Invalid Sachkonten data received:", data);
             throw new Error("Invalid data format received for accounts.");
        }

    } catch (error) {
        console.error("Error in openKautionDialog fetching accounts:", error);
    }


    const dialogHTML = createKautionDialogHTML(sachkontenOptionsHTML);
    modalOverlay.innerHTML = dialogHTML;

    const closeModal = () => {
        console.log('openKautionDialog: closeModal called.');
        const overlay = document.getElementById('kaution-dialog-overlay');
        if (overlay) {
            console.log('openKautionDialog: Removing overlay from body.');
            document.body.removeChild(overlay);
        } else {
             console.log('openKautionDialog: closeModal - overlay not found.');
        }
    };

    if (!document.getElementById('kaution-dialog-overlay')) {
         console.warn("Modal overlay was removed unexpectedly before logic initialization.");
    }


    const modalContentElement = modalOverlay.querySelector('#kaution-dialog-content');
    if (modalContentElement) {
        console.log('openKautionDialog: Found modal content element, initializing logic.');
        initKautionDialogLogic(modalContentElement, closeModal, sachkontenOptionsHTML);
    } else {
        console.error("openKautionDialog: Could not find modal content element (#kaution-dialog-content) to initialize logic.");
    }

     modalOverlay.addEventListener('click', (event) => {
        if (event.target === modalOverlay) {
            closeModal();
        }
    });
} 